import * as React from 'react';
import { SkewImageSeparatorWraper, ImageContainer, Image } from './SkewImageSeparator.s';

type SkewImageSeparatorProps = {
  image: string;
  height: number;
  angle?: number;
  translate?: number;
  margin?: number;
};

export const SkewImageSeparator = (props: SkewImageSeparatorProps) => {
  const { angle = 5, height, image, translate = 0, margin = 0 } = props;
  return (
    <SkewImageSeparatorWraper {...{ height, margin }}>
      <ImageContainer {...{ height, angle }}>
        <Image {...{ height, angle, image, translate }} />
      </ImageContainer>
    </SkewImageSeparatorWraper>
  );
};



// WEBPACK FOOTER //
// src/app/src/components/SkewImageSeparator/SkewImageSeparator.tsx